module.exports = __webpack_public_path__ + "img/costSet.978c649b.svg";